import axios from "axios";

const axiosInstanceV2 = axios.create({
	baseURL: `${process.env.REACT_APP_INFOPULSE_URL}`,
});

export default axiosInstanceV2;
